export const VUE_APP_API_URL = 'https://jxymqtapi.xycmzx.com/api' // 正式地址
// export const VUE_APP_API_URL = 'http://172.16.162.99:8008/api'; //桥
export const VUE_APP_RESOURCES_URL = 'https://jxymqt.xycmzx.com/staticImage/';